import { createFileRoute } from '@tanstack/react-router';

import { RemindersTab } from '@/components/app/org-settings/tabs';
import { PageShell } from '@/components/app/page-shell';
import { Card, CardContent } from '@/components/ui/card';

export const Route = createFileRoute('/_authed/dashboard/settings/reminders')({
  component: RemindersSettingsPage,
});

function RemindersSettingsPage() {
  return (
    <PageShell className="pt-10 pb-8" maxWidth="max-w-[960px]">
      <title>Reminders | Borrah</title>
      <Card>
        <CardContent className="p-0">
          <RemindersTab />
        </CardContent>
      </Card>
    </PageShell>
  );
}
